import { render, staticRenderFns } from "./managedInstructionTagAssignmentDialog.vue?vue&type=template&id=298ae821"
import script from "./managedInstructionTagAssignmentDialog.vue?vue&type=script&lang=js"
export * from "./managedInstructionTagAssignmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports